import { render, staticRenderFns } from "./IndagineEpidemiologicaWestNileEditComponent.vue?vue&type=template&id=e058c180"
import script from "./IndagineEpidemiologicaWestNileEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaWestNileEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports